import ProfileCardModal from './ProfileCardModal';

export default ProfileCardModal;



// WEBPACK FOOTER //
// ./src/components/modals/ProfileCardModal/index.js